import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Gyartas() {
  return (
    <div>
      <Header />
      <div className="text-4xl mt-4 flex justify-center items-center h-screen">
        Gyártás...
      </div>
      <Footer />
    </div>
  );
}
